import styled from 'styled-components/macro';
import LazyImg from 'components/Lazy/img/LazyImg';

export const BooksCardContainer = styled.div`
  position: relative;
  width: 100%;
  height: 0;
  padding-bottom: 142%;
  border-radius: ${({ theme }) => theme.borderRadius.card.books};
  box-shadow: ${({ theme }) => theme.boxShadow.card.books};
  cursor: pointer;
`;
export const BooksCardCover = styled(LazyImg)`
  position: absolute;
  background: ${({ theme }) => theme.background.primary};
  width: 100%;
  height: 100%;
  border-radius: inherit;
  object-fit: cover;
`;
export const BooksCardDescription = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  border-radius: ${({ theme }) => `0 0 ${theme.borderRadius.card.books} ${theme.borderRadius.card.books}`};
  background: ${({ theme }) => theme.background.primary};
  padding: 12px;
  gap: 6px;
  z-index: 1;
`;
const BooksCardDescriptionText = styled.div`
  line-height: 1.1;
`;
export const BooksCardDescriptionName = styled(BooksCardDescriptionText)`
  font-size: 12px;
  font-weight: 400;
`;
export const BooksCardDescriptionAuthors = styled(BooksCardDescriptionText)`
  font-size: 12px;
  font-weight: 500;
`;
